<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">{{ $t('position.nameKh') }} </label>
        <input
          ref="pos_name_kh"
          v-model="model.pos_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('pos_name_kh') }"
          :placeholder="$t('position.enternameKH')"
        />
        <div class="invalid-feedback" v-if="errors.has('pos_name_kh')">
          {{ errors.first('pos_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('position.nameEn') }} <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.pos_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('pos_name_en') }"
          :placeholder="$t('position.enternameEN')"
        />
        <div class="invalid-feedback" v-if="errors.has('pos_name_en')">
          {{ errors.first('pos_name_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('position.parentPosition') }}
        </label>
        <select
          v-model="model.parent_position_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('parent_position_id') }"
        >
          <option value="">{{ $t('select') }}</option>
          <option
            v-for="(parent, index) in parent_positions"
            :key="index"
            :value="parent.position_id"
          >
            {{ parent.pos_name_en }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('parent_position_id')">
          {{ errors.first('parent_position_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('position.level') }} </label>
        <select
          v-model="model.pos_level_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('pos_level_id') }"
        >
          <option value="">{{ $t('select') }}</option>
          <option
            v-for="(level, index) in levels"
            :key="index"
            :value="level.pos_level_id"
          >
            {{ level.pos_level }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('pos_level_id')">
          {{ errors.first('pos_level_id') }}
        </div>
      </div>
      <div class="form-group">
        <ts-checkbox v-model="model.is_active">{{
          $t('position.active')
        }}</ts-checkbox>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          v-if="!is_hris && editing == false"
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'position-create-form',
  props: ['edit'],
  data () {
    return {
      model: {
        pos_name_kh: '',
        pos_name_en: '',
        pos_level_id: '',
        parent_position_id: '',
        is_active: true
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  computed: {
    ...mapState('position', ['levels', 'parent_positions']),
    is_hris () {
      if (this.$store.state.authUser.company) {
        return this.$store.state.authUser.company.is_hris
      }
      return false
    }
  },
  mounted () {
    this.$refs.pos_name_kh.focus()
  },
  created () {
    this.setEdit()
  },
  methods: {
    cancel () {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'position' })
    },

    async save () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('position/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.$store.dispatch('position/getNewParentPostion')
        this.clearForm()
        this.$refs.pos_name_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('position/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'position' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.$store.dispatch('position/getNewParentPostion')
        this.clearForm()
        this.$refs.pos_name_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit () {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm () {
      this.model.pos_name_kh = ''
      this.model.pos_name_en = ''
      this.model.pos_level_id = ''
      this.model.parent_position_id = ''
      this.model.is_active = true
    }
  },
  watch: {
    edit: {
      handler () {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
